import { makeChartComp } from '../../util/makeChartComp';
var RadarChart = makeChartComp('Radar');
export default RadarChart;
